import styled from '@emotion/styled';
import { TextStyle } from 'styles/variables/mixins';
import { Colors } from 'styles/variables/colors';
import { Breakpoints } from 'styles/variables/breakpoints';
import { ReactComponent as PhoneIconComponent } from 'assets/icons/phone-book-a-call-now.svg';

const { white, blue } = Colors;
const { sm, lg, xs } = Breakpoints;

export const Button = styled.button`
    align-self: center;

    width: fit-content;
    white-space: nowrap;
    display: flex;
    align-items: center;
    max-height: 44px;
    gap: 0.5rem;
    padding: 24px 16px;
    background: linear-gradient(90deg, #ef4592 0%, #f19809 100%);
    border-radius: 40px;
    ${TextStyle({ fontSize: '30px', fontWeight: '700', color: white })};
    font-style: normal;
    line-height: 17px;
    text-transform: capitalize;
    transition: all 110ms ease-out;

    &:hover {
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    }

    &:active {
        opacity: 0.9;
    }

    @media screen and (max-width: ${lg}) {
        font-size: 28px;
        gap: 0;
        padding: 9px 13px;
        word-spacing: -1px;
    }

    @media screen and (max-width: ${sm}) {
        font-size: 24px;
    }

    @media screen and (max-width: 575px) {
        font-size: 20px;
        /* margin-top: 1.2rem; */
    }
    @media screen and (max-width: 510px) {
        padding: 8px 18px;
        background: ${blue};
        border-radius: 10px;
        ${TextStyle({ fontSize: '18px', fontWeight: '600', color: white })};
        padding: 12px, 16px, 12px, 16px;
        line-height: 34.13px;
        box-shadow: 0px 4px 4px 0px #000000b2;
    }

    @media screen and (max-width: ${xs}) {
        font-size: 18px;
        padding: 8px 13px;
    }
`;

export const PhoneIcon = styled(PhoneIconComponent)`
    width: 30px;
    height: 30px;
    margin-right: 0.5rem;
    min-width: 24px;

    @media screen and (max-width: ${lg}) {
        width: 25px;
        height: 25px;
    }

    @media screen and (max-width: ${sm}) {
        width: 22px;
        height: 22px;
    }

    @media screen and (max-width: 575px) {
        width: 20px;
        height: 20px;
    }
`;
export const Text = styled.p`
    @media screen and (max-width: 510px) {
        margin: 25px;
        font-size: 27px;
    }
    @media screen and (max-width: ${xs}) {
        margin: 15px;
        font-size: 20px;
    }
`;
